/*
===============================================================================================================
                                 Copyright 2024-2024, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import TextDiv from '@/components/text-div/text-div';
import React from 'react';
import PropTypes from 'prop-types';
/**
 * QRRenderer component
 * @param {Object} props - component props
 * @param {string} props.label - label to display
 * @returns {JSX.Element}
 */
function QRRenderer({ label, selectorId }) {
  return (
    <div className="container" id={selectorId}>
      <div className="qr-wrapper">
        <div className="qr-image-placeholder" />
        <TextDiv>{label}</TextDiv>
      </div>
      <style jsx>
        {`

          .container {
            display: flex;
            flex-direction: column;
            width: 100%;
          }

          .qr-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 20px;
          }

          .qr-image-placeholder {
            width: 156px;
            height: 156px;
            background-color: #f0f0f0;
            margin: 0 auto;
            border-radius: 5px;
            margin-bottom: 10px;
          }
        `}
      </style>
    </div>
  );
}

QRRenderer.defaultProps = {
  label: '',
};

QRRenderer.propTypes = {
  label: PropTypes.string,
  selectorId: PropTypes.string.isRequired,
};

export default QRRenderer;
